import { Component, OnInit } from '@angular/core';
import { DwAction, DwActionButtonComponent, DwActionFunc, DwActionPreference, DwActionType, DwComponent, DwComponentType, DwDecoratorType, DwFilterItemBase, DwFilterType, DwGridActionConfig, DwMenuService, DwMetaDataFilterConfigData, DwMetaDataFilterService, DwMetaDataFilterStateService, DwOperator, DwQueryHelper, DwUiConfigContextBase, getParameterByName } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, PilotExaminerEntity } from '../../../../meta-data/app-meta-data.service';
import { ExaminerTaskDefinition, ExaminerTaskService } from '../../services/examiner-task.service';
import { Router } from '@angular/router';
import { ExaminerRepositoryService } from '../../services/examiner-repository.service';


@DwAction<DwGridActionConfig>({
  keyName: 'examiner-task-filter-action',
  display: 'Examiner Task Filter',
  actionType: DwActionType.gridAction,
  decoratorType: DwDecoratorType.component,
  //configComponent: DwGridQuickSearchConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  allowOnce: true
})
// @DwComponent<DwMetaDataFilterConfigData>({
//   name: 'Examiner Task Filter',
//   componentType : DwComponentType.filterItem,
//   isGlobal: true,
//   configData: {
//     showCaption: true,
//     showCompareType: false,
//     showControlOptions: false,
//     attrType: [],
//     requireAttr: false,
//     showPlaceholderText: false,
//     showDefaultValue: false,
//     allowAttr: false,
//   }
// })
@Component({
  selector: 'app-examiner-task-filter',
  template: `
      <div class="pull-right">
        <div class="dw-chip" [hidden]="!showChip">
            <div class="dw-chip-label-with-remove no-wrap">{{taskText}}</div>
            <div class="dw-chip-icon" (click)="clearItem()"><i class="fa fa-times-circle"></i></div>
        </div>
      </div>
  `
})
export class ExaminerTaskFilterComponent implements DwActionButtonComponent {
  
  showChip: boolean = false;
  actionPreference: DwActionPreference<any, any>; 
  actionContext?: DwUiConfigContextBase;
  taskDef: ExaminerTaskDefinition;

  taskText = '?????';
  constructor(private examinerTaskService: ExaminerTaskService,
    private router: Router,
    private examinerRepositoryService: ExaminerRepositoryService,
    private dwFilterStateService: DwMetaDataFilterStateService
  ) {
    

  }
  clearItem() {
    this.showChip = false;

    this.clearFilter();
  }
  
  setupComponent() {
      const filterTask = getParameterByName(this.router, 'filter');

      if (!filterTask) {
        return;
      }

      this.taskDef = this.examinerTaskService.examinerTaskDefinitions.find(t => t.taskType === filterTask);

      if (!this.taskDef) {
        return;
      }

      this.taskText = `Checkrides ${this.taskDef.titleTextSuffix}`;
      this.showChip = true;

      this.examinerRepositoryService.getCurrentPiloxExaminerStats()
      .subscribe((examiner) => {
        this.setupFilter(examiner);
      });
  }

  setupFilter(examiner: PilotExaminerEntity) {
    const scheuledCheckrides = examiner.ScheduledCheckRideRequest.filter((checkride) => this.examinerTaskService.isScheduledCheckride(checkride));

    const currentCheckrideRequests = scheuledCheckrides.filter((checkride) => this.taskDef.filterFunc(checkride));

    const checkrideIds = currentCheckrideRequests.map((checkride) => checkride.CheckRideRequestId);

    if (checkrideIds.length == 0) {
      checkrideIds.push(-1);
    }
    
    const newFilter = this.buildFilter('CheckRideRequestId', checkrideIds, DwFilterType.In);

    this.applyFilters(newFilter);
  }

  clearFilter() {
    this.applyFilters({});
  }

  private applyFilters(newFilter:any) {
    const allFilters = this.dwFilterStateService.state.filters || {};

    allFilters['GroupExaminerTaskFilter'] = newFilter;

    const preserveFilters = {};

    preserveFilters['GroupExaminerTaskFilter'] = newFilter;

    console.log('Applying filters', newFilter);

    this.dwFilterStateService?.setFilters(allFilters, null, null, true, preserveFilters);
  }

  private buildFilter(attrName: string, value: any, filterType: DwFilterType): any {
    const qh = new DwQueryHelper();

    const filterTypeKey = qh.convertFilterType(filterType);
    const filter: any = {
        Op: DwOperator.And
    };

    // Use the display attribute name which works for text as well as lookups
    const attrFilter: any = filter[attrName] = {};

    //attrFilter.Prefix = attr.RelationPrefix;
    attrFilter[filterTypeKey] = value;

    return filter;
}

}
